<template>

    <div class="col-12 blog_posts row" v-if="is_load">
      <loading-block v-if="is_load==false" :loading="!is_load"/>

      <div class="col-12 col-sm-12 blog_posts_posts col-md-8 col-lg-8   order-last order-md-first order-lg-first">
        <div class="section_black second_section" >
          <ul class="nav justify-content-center widget_nav">
            <li class="nav-item" >
              <a class="nav-link" :class="{'active':orderby=='popular'}" @click="openOrderBy('popular')" >
                Популярное
              </a>

            </li>
            <li class="nav-item" >
              <a tag="button" class="nav-link" :class="{'active':orderby=='last'}" @click="openOrderBy('last')" >
                Новое
              </a>
            </li>
            <li class="nav-item" >
              <a tag="button" class="nav-link" :class="{'active':orderby=='comments'}" @click="openOrderBy('comments')" >
                Обсуждаемое
              </a>
            </li>
          </ul>
        </div>
        <card class="section_black second_section">
          <!-- shape Hero -->

          <!-- 1st Hero Variation -->
          <div class="row d-flex justify-content-center">
            <router-link tag="a" class="btn" :to="{name: 'add_post'}">
              Новая запись
            </router-link>

          </div>
        </card>

        <div class=" " style=""
            v-for="post in posts"
            :key="'post'+post.last_id">
          <div class="blog_post_row post_material_mini block_row">
            <router-link   :to="post.category_post.alias" class="category-link" tag="a">
              <div class="media">
                <img :src="image_url+post.category_post.image"   class="mr-3" style="max-width: 50px; max-height: 50px;">
                <div class="media-body">
                  <h5 class="mt-0">{{ post.category_post.title }}</h5>
                </div>
              </div>
            </router-link>



            <div class="post_material_mini_content">
              <editorjsrender  :blocks_json="post.short.blocks"></editorjsrender>
            </div>
            <div class="d-flex justify-content-between post_material_mini_bottom">
              <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
              <p><i class="fa fa-comment-0"></i>  ({{ post.total_comments_count }})</p>
            </div>


            <router-link class="btn  " :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"
            >
              Читать далее
            </router-link>
          </div>


        </div>



        <div class="col-12 col-sm-12 mt-5 ml-1  " v-if="count>current">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="loadPosts(orderby)">Загрузить еще</button>

          </div>
        </div>

      </div>
      <div class="col-12 col-sm-12  col-md-4 col-lg-4 second_section sidebar_categorys      order-md-2">
        <h4 class="all_blog_categorys_title text-center d-none d-sm-none d-md-block d-lg-block d-xl-block" v-if="last_comments.length>0">Последние<br>комментарии</h4>
        <p v-if="is_show_last_comments==false && last_comments.length>0" class="text-center d-block d-sm-block d-md-none d-lg-none d-xl-none" ><button  @click="toogleLastComments"  class="btn"><i class="fa fa-caret-down"></i> Раскрыть комментарии</button></p>
        <p v-if="is_show_last_comments==true && last_comments.length>0" class="text-center d-block d-sm-block d-md-none d-lg-none d-xl-none" ><button  @click="toogleLastComments"  class="btn"><i class="fa fa-caret-up"></i> Скрыть комментарии</button></p>
        <div class="blog_category_link_mini text-wrap " v-if="last_comments.length>0" ref="listBlogCategorys" :class="{'d-none d-sm-none d-md-block d-lg-block d-xl-block':(is_show_last_comments==false),' ':(is_show_last_comments==true)}" v-for="comment in last_comments"
            :key="'comment'+comment.last_id">

          <div class="row mt-2 mb-2  second_section">
            <div class="col-6 col-md-3   ">
              <img :src="image_url+comment.user.avatar"  class="max_height_100 img-thumbnail"/>
            </div>
            <div class="col-6  col-md-9  title_blog_category  ">
              <p class="text-center"><router-link :to="{name:'post',params:{alias:comment.post.category_post.alias,'id':comment.post.last_id}}">{{ comment.post.title}}</router-link></p>
              <p class="text-center" v-if="comment.comment">{{ comment.comment }}</p>
              <p class="text-center" v-if="!(comment.user && comment.user.isanonymous==true)"><router-link   :to="{'name':'user_page_main','params':{user_id:comment.user_id}}"   tag="a">{{ comment.user.name }}</router-link></p>
              <p class="text-center" ><i class="fa fa-calendar"></i> {{ comment.created_at}}</p>
              <p class="text-center" v-if="(comment.user && comment.user.isanonymous==true)"><button class="btn btn-sm">Анонимус</button></p>
            </div>
          </div>


        </div>
        <h4 class="all_blog_categorys_title text-center d-none d-sm-none d-md-block d-lg-block d-xl-block">Категории</h4>
        <p v-if="is_show_blog_categorys==false" class="text-center d-block d-sm-block d-md-none d-lg-none d-xl-none"><button  @click="toogleBlockCategorys"  class="btn"><i class="fa fa-caret-down"></i> Раскрыть  категории</button></p>
        <p v-if="is_show_blog_categorys==true" class="text-center d-block d-sm-block d-md-none d-lg-none d-xl-none"><button  @click="toogleBlockCategorys"  class="btn"><i class="fa fa-caret-up"></i> Скрыть  категории</button></p>
        <div class="blog_category_link_mini text-wrap " ref="listBlogCategorys" :class="{'d-none d-sm-none d-md-block d-lg-block d-xl-block':(is_show_blog_categorys==false),' ':(is_show_blog_categorys==true)}" v-for="blog_category in categorys"
            :key="'category'+blog_category.last_id">

          <div class="row mt-2 mb-2  second_section">
            <div class="col-6 col-md-3   ">
              <img :src="image_url+blog_category.image"  class="max_height_100 img-thumbnail"/>
            </div>
            <div class="col-6  col-md-9  title_blog_category  ">
              <p class="text-center">{{ blog_category.title}}</p>
              <p class="text-center"><router-link   :to="{'name':'category_blog_orderby','params':{orderby:'last',alias:blog_category.alias}}" class="btn btn-sm"  tag="a">открыть</router-link></p>
            </div>
          </div>


        </div>


      </div>
    </div>


</template>

<script>
import {eventBus} from "@/main";
import Editorjsrender from "@/models/Editorjsrender.vue";
import Api from "@/models/Api";
import Vue from "vue";
import CategoryCard from "@/components/Custom/CategoryCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
export default {
  name: "PostsWidget",
  data: function () {
    return {
      user: null,
      islogin: false,
      is_load:false,
      orderby:"last",
      current: 0,
      count: 0,
      posts: [],
      'is_show_blog_categorys':false,
      'is_show_last_comments':false,
      image_url: null,
      categorys:[],
      last_comments:null,
    }
  },
  mounted() {
    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });
    app.loadPosts();
    app.loadCategorys();

  },
  methods: {
    toogleLastComments(){
      var app=this;
      if(app.is_show_last_comments==false){
        app.is_show_last_comments=true;
      }else {
        app.is_show_last_comments=false;
      }

    },
    toogleBlockCategorys(){
      var app=this;
      if(app.is_show_blog_categorys==false){
        app.is_show_blog_categorys=true;
      }else {
        app.is_show_blog_categorys=false;
      }
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    loadCategorys(){
      var app=this;
      Api.loadBlogCategorys(function(data){

        app.categorys=data;
      });
    },

    openOrderBy(orderby){
      var app=this;
      app.current=0;
      Api.loadPosts(10, 0, function (data) {
        app.count = data.count;
        app.posts = data.posts;
        app.is_load=true;
        app.current = app.current + data.posts.length;
        if(data.last_comments){
          app.last_comments=data.last_comments;
        }


      },orderby);
      app.orderby=orderby;
    },
    loadPosts(set_order_by=null) {
      var app = this;
      var orderby='last';
      if(app.$route.params.orderby){
        orderby=app.$route.params.orderby;
      }
      if(set_order_by){
        orderby=set_order_by;
      }
      app.orderby=orderby;
      Api.loadPosts(10, app.current, function (data) {
        app.count = data.count;
        app.posts = app.posts.concat(data.posts);
        app.is_load=true;
        app.current = app.current + data.posts.length;
        if(data.last_comments){
          app.last_comments=data.last_comments;
        }


      },orderby)
    },
    callWritePost() {
      var params = {

        type: "post_new",

        modal_title: "Добавить пост",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название вашего поста",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
    'CategoryCard':CategoryCard,
    LoadingBlock,
  }
}
</script>

<style scoped>

</style>